import {Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material'
import {StyledCenteredDiv} from '@/components/pages/NewDatasetJobPage/StyledCenteredDiv'
import {ErrorOutline} from '@mui/icons-material'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import React from 'react'

type JobErrorModalProps = {
    message: string,
    isOpen: boolean,
    onClose: () => void,
}

const JobErrorModal = ({message, isOpen, onClose}: JobErrorModalProps) => {
    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
        >
            <DialogTitle/>
            <DialogContent>
                <StyledCenteredDiv>
                    <ErrorOutline color="error" fontSize="large"/>
                </StyledCenteredDiv>
                <Typography paddingTop={2} variant="h1">{message}</Typography>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    )
}

export default JobErrorModal